import { PASSKEY_CONFIG } from '../constants/auth';

/**
 * The origin a passkey belongs to. In a browser that is the page's own origin. The installed app runs from
 * https://localhost inside its WebView, but its passkeys belong to the real domain, so the app reports that instead.
 */
export function getPasskeyOrigin(): string {
  const capacitor = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return capacitor?.isNativePlatform?.() ? PASSKEY_CONFIG.DEFAULT_ORIGIN : window.location.origin;
}
